import { Component, OnInit } from '@angular/core';
import { FieldDashboardDataService } from '../field-dashboard-data.service';

@Component({
  selector: 'app-cost-breakdown',
  templateUrl: './cost-breakdown.component.html',
  styleUrls: ['./cost-breakdown.component.css'],
  standalone: false
})
export class CostBreakdownComponent implements OnInit {
  fieldName: string = '';
  numberOfFields: number = 0;
  totalHectares: number = 0;
  country: string = '';

  constructor(private dataService: FieldDashboardDataService) { }

  ngOnInit(): void {
    this.dataService.fieldData$.subscribe(data => {
      this.fieldName = data.fieldName;
      this.numberOfFields = data.numberOfFields;
      this.totalHectares = data.totalHectares;
      this.country = data.country;
    });
  }
}
